<template>
  <generic-update :model="model">
    <template v-slot:form="{ error, fetch, item, loading, submit }">
      <transport-company-form
        :with-data="item"
        :error="error"
        :loading="loading"
        @submit="submit"
        @reset="fetch"
      />
    </template>
  </generic-update>
</template>

<script>
import TransportCompanyForm from "./Form"
import model from "./model"

export default {
  components: { TransportCompanyForm },
  data() {
    return {
      model,
      localData: {},
    }
  },
}
</script>
